// Exports
// -------

// Utility for debouncing repeated calls to a given function (i.e. execute the
// function once per string of calls)
//
// Args:
//  1. `fn` - Function to be debounce
//  2. `delay` - How long to delay function execution in milliseconds. If this
//     argument is a `Boolean` it will be treated as the `fireNow` flag
//  3. `executeImmediately` - Flag to indicate whether or not to execute the
//     `fn` immediately (first run); (false by default)
//
// Returns: Debounced function
//
// Usage:
//  ```javascript
//  import debounce from 'debounce';
//  $(window).on('resize', debounce(doSomethingNifty, 100));
//  ```
export default function _debounce(fn, delay, executeImmediately = false) {

  var timeout;

  // TODO: Add utility for ensuring arg type
  if (typeof fn !== 'function') {
    throw new TypeError('debounce: The debounce method expects the fn argument to be a function');
  }

  // Function that gets executed on timeout
  function later(args) {
    timeout = null;

    if (!executeImmediately) {
      fn.apply(this, args);
    }
  }

  // Debounced function
  return function () {

    if (executeImmediately && !timeout) {
      fn.apply(this, arguments);
    }

    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(later.bind(this, arguments), delay);
  };
}
